module.exports = __webpack_public_path__ + "img/store-active.0e0e250c.svg";